import * as React from 'react';
import { Tooltip } from '@grnhse/seedling/lib/birch/components/tooltips/';
import styled from 'styled-components';
type ConditionalTooltipProps = {
  children: React.ReactElement;
  label: string;
  when: boolean;
  block?: boolean;
};

const ConditionalTooltip = ({
  when,
  label,
  children,
  block = false,
}: ConditionalTooltipProps) => {
  if (when) {
    return (
      <StyledTooltip block={block}>
        <Tooltip label={label} ariaLabel={label}>
          {children}
        </Tooltip>
      </StyledTooltip>
    );
  } else {
    return children;
  }
};

const StyledTooltip = styled.div<{ block: boolean }>`
  span {
    ${(props) =>
      props.block && {
        flex: 1,
      }}
  }
`;

export default ConditionalTooltip;
